import utils from '@/utils/commonUtils'
import Vue from 'vue'
let naiveDialogInfo = {
    name: "dialogCdRwInformation",
    inheritAttrs: false,
    render(h) {
        return(h)
        // if (this.$scopedSlots.content)
        //     return this.$scopedSlots.content(this);
        // return h('el-button', {on: {click: this.openDialog}, attrs: this.$attrs}, this.$slots.default);
    },
    // components:{
    //     OwnerButton
    // },
    props: {
        /** dialog 参数 / 默认支持elementUI dialog基本配置 注意以下配置：
         title 标题 （未传递header插槽生效）
         titleStyle 标题文字样式 （未传递header插槽生效）
         icon 标题图标 class （未传递header插槽生效）
         */
        dialogConfig: {
            type: Object, required: true
        },
        /**
         *  dialog 事件注册
         */
        dialogListeners: {
            type: Object
        },
        /**
         *  具体组件配置项
         */
        assemblyConfig: {//指定组件配置
            type: Object, required: true
        },
        /**
         *  具体组件事件注册
         */
        assemblyListeners: {
            type: Object
        },
        /**
         * 路由路径
         */
        namespace: {
            type: [String, Array],
            required: true
        },
        /**
         * 是否销毁上一个实例
         */
        whetherDestruction: {
            type: Boolean,
            default: false
        }
    }, data() {
        return {
            instance: undefined,
        };
    },
    methods: {
        openDialog() {
            let vm = this;
            if (vm.instance) {
                vm.instance.openDialog();
                return;
            }
            utils.useComponent(vm.namespace, (targetComponent) => {

                utils.useComponent("component-dialog", (dialogComponent) => {
                    if (!vm.$createCdRwInformationDialog)
                        Vue.createAPI(dialogComponent, false);
                    let $scopedSlots = {};
                    if (vm.$scopedSlots.foot)
                        $scopedSlots.foot = vm.$scopedSlots.foot;
                    if (vm.$scopedSlots.header)
                        $scopedSlots.header = vm.$scopedSlots.header;
                    if (vm.instance)
                    {
                        vm.instance.remove();
                        vm.instance = undefined;
                    }
                    vm.instance = vm.$createCdRwInformationDialog({
                        $props: {
                            dialogConfig: vm.dialogConfig,
                            assemblyConfig: vm.assemblyConfig,
                            assemblyListeners: vm.assemblyListeners,
                            component: targetComponent,
                            dialogListeners: vm.dialogListeners,
                            whetherDestruction: vm.whetherDestruction,
                        },
                        $scopedSlots,
                        $events: {
                            remove() {
                                if(vm.instance)
                                    vm.instance.remove()
                                vm.instance = undefined;
                            }
                        }
                    }, false);
                    vm.instance.$parent.destroy = function(){
                        this.$destroy();
                        if (this.$el && this.$el.parentNode) {
                            this.$el.parentNode.removeChild(this.$el);
                        }
                    }
                })
            })
        }
    }
}


export default naiveDialogInfo



